import { EventEmitter } from "fbemitter";
import { SearchFn } from "../../../../rest/Search";
import { Division } from "../../../../models";
import { CurrentDivisionActions } from "../flux/CurrentDivisionActions";
import { ErrorActions } from "../../../flux/Error";
import { FlagActions } from "../../../flux/Flag";
import { Command1 } from "../../../../Command";

export class ChangeCurrentDivisionCommand implements Command1<number>
{
    private actions = new CurrentDivisionActions();
    private errorActions = new ErrorActions();
    private inProgress = new FlagActions();
    
    constructor(private runSearch: SearchFn, private emiter: EventEmitter,  private inProgressDispatchToken: string, private errorDispatchToken: string)
    {
    }

    execute = (targetDivisionId: number) => {
        this.inProgress.set(this.inProgressDispatchToken);
        const success = this.runSearch({ Name: 'Divisions' })
            .then(res => {
                this.actions.setTarget(targetDivisionId, res.Entries.Division);
                this.emiter.emit('division', targetDivisionId);
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken, 5 * 1000))
            .then(() => this.inProgress.reset(this.inProgressDispatchToken)); // finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/DivisionPath/commands/ChangeCurrentDivisionCommand.ts